import qs from 'qs';

import { getCookie } from '@atlassian/browser-storage-controls';

import { appWasServerSideRendered, isHydrated } from 'src/utils/ssr';

export enum PipelinesEnvEnum {
  'PRODUCTION' = '',
  'DDEV' = 'ddev',
  'STAGING' = 'stg',
}

export type apiPrefix = '/!api/internal' | '/!api/2.0';
export type apiKey = 'pipelines' | 'deployments';

export const getEnv = () => {
  const envFallback =
    isHydrated() && !appWasServerSideRendered()
      ? getCookie('bbc-frontbucket-pipelines-env') ?? ''
      : '';

  return (
    (qs.parse(location.search, { ignoreQueryPrefix: true }).env as string) ??
    envFallback
  );
};

export const getEnvKey = () => {
  const env = getEnv();
  if (env === PipelinesEnvEnum.STAGING) {
    return 'STAGING';
  } else if (env === PipelinesEnvEnum.DDEV) {
    return 'DDEV';
  }
  return `PRODUCTION`;
};

export const getAddonKey = () => {
  const env = getEnv();
  if (env === PipelinesEnvEnum.STAGING) {
    return `pipelines-stg`;
  } else if (env === PipelinesEnvEnum.DDEV) {
    return `pipelines-ddev`;
  }
  return `pipelines`;
};

export const getWebSocketUrl = () => {
  const env = getEnv();
  if (env === PipelinesEnvEnum.STAGING) {
    return `wss://bitbucketci-ws-service.stg.services.atlassian.com/ws`;
  } else if (env === PipelinesEnvEnum.DDEV) {
    return `wss://bitbucketci-ws-service.dev.services.atlassian.com/ws`;
  }
  return `wss://bitbucketci-ws-service.services.atlassian.com/ws`;
};

// eslint-disable-next-line import/no-default-export
export default function (
  apiPrefix: apiPrefix = '/!api/2.0',
  apiKey: apiKey = 'pipelines',
  // some environment APIs are inconsistent
  fixInternal = false
) {
  const env = getEnv();
  const newInternalPipelinesApiPart =
    apiPrefix === '/!api/2.0' ? '' : '/internal';
  const internalPipelinesApiPart =
    apiPrefix === '/!api/2.0' ? '' : fixInternal ? '' : '/internal';
  if (env === PipelinesEnvEnum.STAGING) {
    return `/!api/internal/${apiKey}/stg${newInternalPipelinesApiPart}`;
  } else if (env === PipelinesEnvEnum.DDEV) {
    return `/!api/internal/${apiKey}/ddev${internalPipelinesApiPart}`;
  }
  return apiPrefix;
}
